define([
    'handlebars',
    'moment-wrapper',
    'mixins/models/projectbased',
    'appcontext'
], (Handlebars, moment, Model, appContext) => Model.extend({
    urlRoot: '/placements',

    defaults () {
        return {
            id: null,
            project_id: null,
            channel_id: null,
            connection_id: null,
            name: null,
            campaign_xid: null,
            daily_budget: null,
            utm_source: null,
            utm_medium: null,
            utm_campaign: null,
            labels: [],
            orders: []
        };
    },

    getChannelId () {
        return this.get('channel_id');
    },

    isArchived () {
        return this.get('status') === 'ARCHIVED';
    },

    isTimeGranulation () {
        const ids = [
            appContext.channelByName('facebook').id,
            appContext.channelByName('vkontakte').id,
            appContext.channelByName('twitter').id
        ];
        return _.indexOf(ids, this.get('channel_id')) !== -1;
    },

    // checks if time is valid for some channel within account/user timezone conversions and returns corrected time
    checkTime (value) {
        if (!value || this.get('channel_id') !== appContext.channelByName('vkontakte').id) {
            return value;
        }

        const timezones = appContext.timezones();
        const userZone = timezones.where({timezone: appContext.user().get('timezone')})[0];
        const accountZone = timezones.where({timezone: appContext.account().get('timezone')})[0];
        let datetime = moment(value).replaceZone(userZone.get('utcoffset') / 60);

        datetime = datetime.zone(0).utc();

        // operating in account timezone
        datetime = datetime.zone(accountZone.get('name'));

        // trimming minutes and seconds
        datetime.minutes(0);
        datetime.seconds(0);

        datetime = datetime.zone(userZone.get('name'));
        return datetime;
    },

    isFineTuned () {
        return this.get('is_fine_tuned');
    }
}));
